const initialState = {
  // Remember whether cancelled activity events are shown
  showCancelled: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_SHOW_CANCELLED':
      return {
        ...state,
        showCancelled: !!action.payload,
      };

    default:
      return state;
  }
}

export function setShowCancelledActivityAction(show) {
  return {
    type: 'SET_SHOW_CANCELLED',
    payload: show,
  };
}
